module.exports = __webpack_public_path__ + "static/Terminal_RedMoon.f2315056b4e1d6f85c288e45fd69dd15.png";